import { Button, DataSource, Layout, Panel, Switch } from "@mcleod/components";

export abstract class AutogenLayoutDriverChoice extends Layout {
    buttonSearchPreferences: Button;
    panel1: Panel;
    panelTable: Panel;
    sourceDriverChoice: DataSource;
    switchSwitch1: Switch;
}
